import React from 'react';
import { Radio, Shield, Activity, FileText, Layout, Network } from 'lucide-react';

interface TabProps {
  label: string;
  icon: React.ElementType;
  count?: number;
}

const BASE_TABS: TabProps[] = [
  { label: 'Overview', icon: Layout },
  { label: 'Ports', icon: Radio },
  { label: 'Findings', icon: Shield },
  { label: 'Events', icon: Activity },
  { label: 'Notes', icon: FileText },
];

interface AssetDetailTabsProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
  assetId: string;
  portsCount?: number;
  findingsCount?: number;
  eventsCount?: number;
}

export const AssetDetailTabs: React.FC<AssetDetailTabsProps> = ({
  activeTab,
  onTabChange,
  assetId,
  portsCount,
  findingsCount,
  eventsCount
}) => {
  const tabs = BASE_TABS.map(tab => {
    switch (tab.label) {
      case 'Ports':
        return { ...tab, count: portsCount };
      case 'Findings':
        return { ...tab, count: findingsCount };
      case 'Events':
        return { ...tab, count: eventsCount };
      default:
        return tab;
    }
  });
  return (
    <div className="bg-[#0F1629] rounded-xl border border-gray-800/50">
      {/* Tab Navigation */}
      <div className="border-b border-gray-800">
        <nav className="flex space-x-4 px-6" aria-label="Tabs">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            const isActive = activeTab === tab.label.toLowerCase();
            
            return (
              <button
                key={tab.label}
                onClick={() => onTabChange(tab.label.toLowerCase())}
                className={`flex items-center space-x-2 py-4 px-3 text-sm font-medium border-b-2 ${
                  isActive
                    ? 'border-blue-500 text-blue-500'
                    : 'border-transparent text-gray-400 hover:text-gray-300 hover:border-gray-700'
                }`}
              >
                <Icon className="h-4 w-4" />
                <span>{tab.label}</span>
                {tab.count !== undefined && (
                  <span className={`px-2 py-0.5 rounded-full text-xs ${
                    isActive ? 'bg-blue-500/20' : 'bg-gray-800'
                  }`}>
                    {tab.count}
                  </span>
                )}
              </button>
            );
          })}
        </nav>
      </div>
    </div>
  );
};